export default __webpack_public_path__ + "static/media/soustitre1.e817bfeb.jpeg";